// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Qom5","title":"Header_title__3t8ZR","side":"Header_side__2XEse"};